<div class="line-chart-container" [class.noBg]="removeBackgroundColor">
  <canvas id="{{ chartId }}"></canvas>
  <ng-content></ng-content>
</div>
